module.exports = __webpack_public_path__ + "DN_compact.svg";